// extracted by mini-css-extract-plugin
module.exports = {"container":"pages-tickets-container"};